(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/greetings-input.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/greetings-input.js');
"use strict";


const TextInput = svs.ui.reactFormInputs.TextInput;
const _svs$tickets_giftshop = svs.tickets_giftshop.functions,
  byteSize = _svs$tickets_giftshop.byteSize,
  giftformValidator = _svs$tickets_giftshop.giftformValidator;
const _svs$tickets_giftshop2 = svs.tickets_giftshop.constants.form,
  GREETINGS_MAX = _svs$tickets_giftshop2.GREETINGS_MAX,
  GREETINGS_MAX_ERROR = _svs$tickets_giftshop2.GREETINGS_MAX_ERROR,
  INVALID_INPUT_ERROR = _svs$tickets_giftshop2.INVALID_INPUT_ERROR,
  GREETINGS_LABEL = _svs$tickets_giftshop2.GREETINGS_LABEL;
const GreetingsInput = _ref => {
  let onChange = _ref.onChange,
    value = _ref.value,
    onBlur = _ref.onBlur,
    name = _ref.name;
  const validationHandler = value => {
    const validationResult = {
      errorMessage: '',
      isValid: true
    };
    if (giftformValidator.hasInvalidGreetingsCharacters(value)) {
      validationResult.errorMessage = INVALID_INPUT_ERROR;
      validationResult.isValid = false;
    } else if (byteSize(value, true) > GREETINGS_MAX) {
      validationResult.errorMessage = "".concat(GREETINGS_MAX_ERROR, " ").concat(byteSize(value, true), "/").concat(GREETINGS_MAX, ".");
      validationResult.isValid = false;
    }
    return validationResult;
  };
  return React.createElement(TextInput, {
    autoCapitalize: "sentences",
    id: name,
    isMultiline: true,
    isRequired: false,
    label: GREETINGS_LABEL,
    max: GREETINGS_MAX,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    rows: 6,
    showCharCounter: true,
    validateFn: validationHandler,
    value: value
  });
};
svs.tickets_giftshop.gift.giftform.components.GreetingsInput = GreetingsInput;

 })(window);